import { render } from "./AiReportTop.vue?vue&type=template&id=2fd63d57&ts=true"
import script from "./AiReportTop.vue?vue&type=script&lang=ts"
export * from "./AiReportTop.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__